import cx from 'classnames';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../../ricos-context';

import type { ToolbarButtons } from '../../../models';
import { TOOLBAR_DATA_HOOK, TOOLBAR_VISIBLE } from '../data-hooks';
import { MobileToolbarOverlay } from './mobile-toolbar-overlay/mobile-toolbar-overlay';
import styles from './RicosMobileToolbar-scss';

type MobileToolbarProps = {
  maxWidth: number;
  toolbarButtons: ToolbarButtons;
  type: 'floating' | 'static' | 'regular';
};

export const RicosMobileToolbar = ({ maxWidth, toolbarButtons, type }: MobileToolbarProps) => {
  const { languageDir } = useContext(RicosContext);
  const [mobileToolbar, setMobileToolbar] = useState<HTMLDivElement | null>(null);

  return (
    <div
      className={cx(styles.container, {
        [styles.regularContainer]: type === 'regular',
        [styles.floatingContainer]: type === 'floating',
        [styles.staticContainer]: type === 'static',
      })}
    >
      <MobileToolbarOverlay mobileToolbar={mobileToolbar} maxWidth={maxWidth}>
        <div
          dir={languageDir === 'rtl' ? 'rtl' : 'ltr'}
          data-hook={TOOLBAR_DATA_HOOK}
          className={cx(styles.mobileToolbar, {
            [styles.toolbarFloating]: type === 'floating',
            [styles.toolbarStatic]: type === 'static',
          })}
          style={{
            maxWidth,
          }}
          ref={ref => {
            setMobileToolbar(ref);
          }}
        >
          <div className={styles.buttons} data-hook={TOOLBAR_VISIBLE}>
            {toolbarButtons.getButtonsElementsWithDataHook()}
          </div>
        </div>
      </MobileToolbarOverlay>
    </div>
  );
};
